import { useDialogStore } from '@/components/dialogs';
import { registerToastActionHandler } from '@/feature/notifications';
import useAppStore from '../../store/rootStore';
import { router } from '../../router';

// Side-effect module: imported once from uiProviders.tsx to register the toast
// action handlers used by liquidation alerts. Don't drop the import as "unused".
registerToastActionHandler('switchToMarket', ({ marketId }) => {
  const market = useAppStore.getState().markets.get(marketId);
  if (!market?.symbol) return;
  void router.navigate({ to: '/trade/$marketSymbol', params: { marketSymbol: market.symbol } });
});

// The "Open Settings" link on a liquidation alert opens the preferences drawer,
// mirroring the one-click-trading tooltip's "Enable in Settings" affordance.
registerToastActionHandler('openSettings', () => {
  useDialogStore.getState().openDialog('userPreferencesDrawer');
});
